module.exports = __webpack_public_path__ + "static/media/Register-Illustration.44560908.svg";